import * as Yup from "yup";


export const validateResponsables = Yup.object({
  nombreApellidoContacto: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Ingrese sólo letras y espacios")
    .max(50, "Máximo 50 caracteres")
    .optional(),
  dniContacto: Yup.number()
    .min(10000000, "Mínimo 8 dígitos")
    .max(99999999, "Máximo 8 dígitos")
    .integer("No ingrese caracteres especiales")
    .nullable()
    .typeError("Ingrese sólo números")
    .when('nombreApellidoContacto', {
      is: (nombreApellidoContacto) => nombreApellidoContacto && nombreApellidoContacto.trim().length > 0,
      then: (schema) => schema.required('DNI es requerido si se ingresa un contacto en la obra'),
      otherwise: (schema) => schema.optional()
    }),
  telefonoContacto: Yup.string()
    .matches(
      /^[0-9]*$/,
      "Solo se permiten números"
    )
    .max(50, "El número de teléfono debe tener como máximo 50 caracteres")
    .when('nombreApellidoContacto', {
      is: (nombreApellidoContacto) => nombreApellidoContacto && nombreApellidoContacto.trim().length > 0,
      then: (schema) => schema.required('DNI es requerido si se ingresa un contacto en la obra'),
      otherwise: (schema) => schema.optional()
    }),
  mailContacto: Yup.string()
    .max(255, "Máximo 255 caracteres")
    .matches(
      /@.*\.com/,
      "Ingrese una dirección de correo válida"
    )
    .email("Ingrese una dirección de correo válida")
    .optional(),
  responsableSeguridadHigiene: Yup.string().required("Campo obligatorio").nullable(),
});
